module.exports = __webpack_public_path__ + "img/atelier.62eecb2c.svg";